module.exports = __webpack_public_path__ + "static/img/mx.29e35fb5.svg";